/**
 * VenueBlackoutService
 * Service for VenueBlackout entity operations
 * Route: api/venueblackouts
 * Controller: VenueBlackoutsController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * VenueBlackoutService
 * Handles venue blackout CRUD operations and custom endpoints
 * Maps to /api/venueblackouts endpoint
 */
export class VenueBlackoutService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VenueBlackoutService.DEFAULT_SERVICE_PATH,
            basePath: VenueBlackoutService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== CUSTOM METHODS ====================
    /**
     * Get all blackouts for a venue
     * GET /api/venueblackouts/venue/{venueId}
     * @param venueId - Venue ID
     * @returns Array of venue blackouts
     */
    async getByVenue(venueId) {
        const response = await this.getByVenueRaw(venueId);
        return response.data ?? [];
    }
    getByVenueRaw(venueId) {
        const url = this.buildUrl('venue/' + venueId);
        return this.http.get(url);
    }
}
VenueBlackoutService.DEFAULT_SERVICE_PATH = 'meetings';
VenueBlackoutService.BASE_PATH = 'api/venueblackouts';
//# sourceMappingURL=VenueBlackoutService.js.map